import { string, number, bool } from "prop-types";
import { Tables } from "@repo/utils";
import {
  useEstimateEditorSettings,
  useEstimateStructure,
  TableSummary,
  TableTimeline,
  TableBreakdown,
  TextDescription,
} from "@tools";

export const EditorTablesFactory = ({
  index,
  isLast,
  tableName,
  noBottomBar,
}) => {
  const {
    breakdownTableIndex,
    blockExpansions,
    useProfitability,
  } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  
  const { visibility, displayAnyValue } = structure;
  
  const {
    apply,
    hideBreakdown,
    hideTimeline,
    hideTextDescription,
  } = visibility;
  
  const commonProps = {
    tableIndex: index,
    isLastTable: isLast,
    tableBreakdownNext: breakdownTableIndex >= 0 && breakdownTableIndex === index+1,
    tableBreakdownPrev: breakdownTableIndex >= 0 && breakdownTableIndex === index-1,
  }
  
  switch (tableName) {
    case Tables.SUMMARY:
      return <TableSummary
        {...commonProps}
        noBottomBar={noBottomBar}
        blockExpansions={blockExpansions || useProfitability}
      />;
    case Tables.TIMELINE:
      if(apply && (hideTimeline || !displayAnyValue))
        return <></>
      return <TableTimeline {...commonProps} />;
    case Tables.BREAKDOWN:
      if(apply && hideBreakdown)
        return <></>
      return <TableBreakdown {...commonProps} />;
    case Tables.DESCRIPTION:
      if(apply && hideTextDescription)
        return <></>
      return <TextDescription {...commonProps} />;
  }
};

EditorTablesFactory.propTypes = {
  index: number,
  isLast: bool,
  tableName: string,
  noBottomBar: bool,
};
